module.exports = __webpack_public_path__ + "img/background-desktop-default.58562cd2.png";